module.exports = __webpack_public_path__ + "static/img/mobile-web-swiper03.6496999.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/db-life-smart-phone-sales/mobile-web-swiper03.png
// module id = 45tR
// module chunks = 0